import { NgModule } from '@angular/core';
import { AvanoToggleButtonGroupComponent } from './avano-toggle-button-group.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [AvanoToggleButtonGroupComponent],
  exports: [AvanoToggleButtonGroupComponent]
})
export class AvanoToggleButtonGroupModule { }
